import { MRT_ColumnDef } from "material-react-table";
import { Job } from "../../../../api";
import { ColumnContext, geoJSONFileColumn } from "./ColumnHelpers";

export function column_BoundaryGeoJSON(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return geoJSONFileColumn(context, "boundaryOptions", "boundaryGeoJSON", "boundaryGeoJSON");
}
